import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const token = sessionStorage.getItem('Token');
  const isAuthenticated = Boolean(token);
  
  console.log('ProtectedRoute - Token:', token);
  console.log('ProtectedRoute - Is Authenticated:', isAuthenticated);
  
  if (!isAuthenticated) {
    console.log('Redirecting to login');
    return <Navigate to="/login" />;
  }
  
  console.log('Rendering protected content');
  return <Outlet />;
};

export default ProtectedRoute;